import { Component } from "react";
import React from "react";

export default class Pagination extends Component{
  
  /*const { 
    pagesModal, 
    previousPageModal,
    selectPageModal,
    nextPageModal,
    pagesModalState,
  } = this.props.*/
  
  
    render(){
        const componentRender = () =>{
          if(this.props.pagesModal.length > 9){
            return (
              <>
                {parseInt(this.props.pagesModalState) > 0 && this.props.pagesModal.length > 6 ?
                  <>
                    <li
                      className={(String(this.props.pagesModal[0]) === String(parseInt(this.props.pagesModalState)+1)) ? "selected" : ""}
                      data-page={this.props.pagesModal[0]}
                      onClick={this.props.selectPageModal}
                    >{this.props.pagesModal[0]}</li>
                    <span style={{display: this.props.pagesModalState > 1 ? 'flex' : 'none'}}>...</span>
                  </>
                : ""
                }
              {
                this.props.pagesModal
                  .filter((value) => this.props.pagesModal.length > 5 
                    ? (this.props.pagesModalState >= this.props.pagesModal.length - 5 
                      ? (value > this.props.pagesModalState - 5 && value <= this.props.pagesModalState+1) 
                      : (value < this.props.pagesModalState + 5 && value > this.props.pagesModalState)) 
                    : value)
                  .map((value, index) => (
                    <>
                      <li
                        className={(String(value) === String(parseInt(this.props.pagesModalState)+1)) ? "selected" : ""}
                        data-page={value}
                        onClick={this.props.selectPageModal}
                      >{value}</li>
                    </>
                ))
                }
                {this.props.pagesModalState < this.props.pagesModal.length - 1 && this.props.pagesModal.length > 5 ?
                  <>
                    <span style={{display: this.props.pagesModalState < this.props.pagesModal.length - 2 ? 'flex' : 'none'}}>...</span>
                    <li
                      className={(String(this.props.pagesModal[this.props.pagesModal.length-1]) === String(parseInt(this.props.pagesModalState)+1)) ? "selected" : ""}
                      data-page={this.props.pagesModal[this.props.pagesModal.length-1]}
                      onClick={this.props.selectPageModal}
                    >{this.props.pagesModal[this.props.pagesModal.length-1]}</li>
                  </>
                : ""
                }
              </>
            )
          }else{
            return( 
              <>
                {this.props.pagesModal
                  .map((value, index) => (
                    <>
                      <li
                        className={(String(value) === String(parseInt(this.props.pagesModalState)+1)) ? "selected" : ""}
                        data-page={value}
                        onClick={this.props.selectPageModal}
                      >{value}</li>
                    </>
                ))
                }
              </>
            )
          }
        }
        return(
            <>
                {this.props.pagesModal.length > 1 ?
                <div className="loader__pagerModal__container">
                    <div className="loader__pagerModal__left" style={this.props.pagesModalState === 0 ? {pointerEvents: 'none', opacity: 0.4} : {}}  onClick={this.props.previousPageModal}></div>
                    <div className="loader__pagerModal__pages">
                    <ul>
                        {componentRender()}
                    </ul>
                    </div>
                    <div className="loader__pagerModal__right" style={this.props.pagesModal.length === (this.props.pagesModalState+1) ? {pointerEvents: 'none', opacity: 0.4} : {}} onClick={this.props.nextPageModal}></div>
                </div>
                : ""}
            </>
        )
    }
}
